import styled from 'styled-components';

export const BusinessDetailsWrap = styled.div(
    props => `
        width:100%;
        flex-direction: column;
        padding-top:2rem;
        opacity: ${props.disabled ? '0.2' : '1'};
        pointer-events: ${props.disabled ? 'none' : ''};
        display: ${props.disabled ? 'none' : 'flex'};
    `
);

export const BusinessDetailsInfoWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        
    `
);

export const BusinessDetailsInfoHeadWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        position:relative;

        span{
            position: absolute;
            top:50%;
            right:0;
            width:80%;
            height:0.1rem;
            background-color: rgba(0,0,0,0.5);
        }
        @media(max-width:1023px){
            span{
                width:65%;
            }
        }
    `
);

export const BusinessDetailsInfoHeadText = styled.p(
    props => `
        font-size: 1.2rem;
        color: #4c4c4c;
        font-weight: bold;
        text-transform: uppercase;
    `
);

export const BusinessDetailMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        padding-top: 2rem;
        flex-direction: column;
    `
);

export const GstBlockWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        justify-content: space-between;
        align-itmes: center;
        padding-bottom:${props.theme.spacing.large.l15};
        position: relative;
        opacity: ${props.disabled ? '0.4' : '1'};
        pointer-events: ${props.disabled ? 'none' : ''};
    
        @media only screen and (min-width:320px) and (max-width: 1023px){
            padding-bottom: ${props.theme.spacing.base};
        }
    `,
)

export const KycNumberWrap = styled.div(
    props => `
        width:60%;
        display: flex;
        flex-direction: column;
    `
);

export const NoKycCheckWrap = styled.div(
    props => `
        width:40%;
        display: flex;
        align-items: center;
    `
);

export const GstDisabelWrap = styled.div(
    props => `
            width:100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
    `,
);

export const GstDisableText = styled.p(
    props => `
        font-size:${props.theme.font.large.font15};
        color: ${props.theme.colors.black.light5};

        @media only screen and (min-width:320px) and (max-width: 767px){
            font-size: ${props.theme.font.large.font14};
        }
    `,
);

export const GstInCheckBox = styled.input.attrs({type: 'checkbox'})(
    props => `
        margin-right: ${props.theme.spacing.small.s5};
        margin-top: ${props.theme.spacing.small.s2};
        cursor: pointer;
    `,
);

export const StateCityWrapper = styled.div(
    props => `
          width:100%;
          display: flex;
          justify-content: space-around;
  
          @media only screen and (min-width:320px) and (max-width: 767px){
              flex-direction: column;
          }
      `,
);

const InputBlock = styled.input(
    props => `
      width: 95%;
      height: 4.2rem;
      cursor: pointer;
      border: 1px solid ${props.theme.colors.grey.lightd0};
      background-color: ${props.theme.colors.white.base};
      border-radius: ${props.theme.misc.borderRadius.small};
      border-color: ${props.hasError ? props.theme.colors.red.base : ''}
      font-size: ${props.theme.font.large.font16};
      padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
      color: ${props.theme.colors.grey.base};
      font-weight: ${props.theme.font.fontWeight.bold};
  
      ::placeholder {
        lin-height: ${props.theme.font.lineHeight.large};
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.lightc5};
        overflow: visible;
      }
    `
)
  
export const InputState = styled(InputBlock)(
    props =>`
        width: 100%;
        @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-right: ${props.theme.spacing.nospacing};
        margin-bottom: ${props.theme.spacing.base};
        }
`);
  
export const InputCity = styled(InputBlock)(
    props => `
        @media only screen and (min-width: 320px) and (max-width: 767px) {
        width: 100%;
        margin-right: ${props.theme.spacing.nospacing};
        margin-bottom: ${props.theme.spacing.base};
        }
`);

export const InputPincode = styled(InputBlock)(
    props =>`
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            width: 100%;
            margin-bottom: ${props.theme.spacing.base};
        }
`);

export const NoGstnMsg = styled.p(
    props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.small.s5} 0;
        font-size: ${props.theme.spacing.large.font12};
        color: ${props.theme.colors.red.base};
        span{
            font-weight: bold;
        }
    `
);